<template>
  <div id="topbar-container">
    <div id="topbar-left">
      <div id="main-nav" class="d-none">
        <router-link
            v-slot="{ href, route, navigate, isActive, isExactActive }"
            :to="{ name: 'Tools', params: { uuid: id } }"
        >
          <div
              :class="[isActive && '', isExactActive && 'exact-active']"
              class="nav-item d-flex d-inline-flex align-items-center h-100 gap-50"
              @click="navigate"
          >
            {{ 'Tools' | trans }}
          </div>
        </router-link>
      </div>

      <div id="files-bar-container" class="open-files-nav flex-1 overflow-x-auto no-scrollbar" @wheel="onWheel">
        <router-link
            v-for="(job, index) in resultPage.openTabs"
            :key="index"
            v-slot="{ href, route, navigate, isActive, isExactActive }"
            :to="job.path"
        >
          <div
              :class="[isActive && 'active', isExactActive && 'active']"
              class="nav-item-file"
              @click="openTab(job)"
              @click.middle="remove(job.id, index, isActive)"
          >
            <div class="tab-icon">
              <i v-if="currentJob.state !== 'processing'" class="lh-inherit" :class="job.icon"></i>
              <i v-if="loading" class="lh-inherit spin-circle-basic"></i>
              <strong v-if="job.type === 'preview_image'">Preview</strong>
              <strong v-if="job.type === 'file_list'"></strong>
              <i v-if="job.state === 'processing'" class="fa fa-spin btn-loading-animation lh-inherit"></i>
            </div>
            <div class="file-text">{{ job.name }}</div>
            <i
                class="far fa-times lh-inherit"
                v-if="job.dismissable"
                @click.stop="remove(job)"
            ></i>
            <span v-if="!job.dismissable"></span>
          </div>
        </router-link>

        <div class="nav-item-file nav-item-file-new" @click="createJob">
          <i class="fa fa-plus lh-inherit"></i> {{ 'New' | trans }}
        </div>
      </div>

      <div class="topbar-scroll-container" v-if="resultPage.openTabs.length > 2">
        <i class="lh-inherit fa fa-chevron-left" @click="scrollLeft"></i>
        <i class="lh-inherit fa fa-chevron-right" @click="scrollRight"></i>
      </div>
    </div>
    <div id="topbar-right">
      <div class="d-flex justify-content-end h-100 ">
        <router-link
            v-slot="{ href, route, navigate, isActive, isExactActive }"
            :to="{ name: 'Feedback', params: { uuid: id } }"
        >
          <div
              :class="[isActive && '', isExactActive && 'exact-active']"
              class="nav-item"
              @click="navigate"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <g fill="none" fill-rule="evenodd">
                <path
                    d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"/>
                <path fill="currentColor"
                      d="m20.255 5.52l.087.298l.089.338l.044.185l.089.4l.085.443l.081.485c.026.169.05.345.074.528l.065.572c.08.791.131 1.7.131 2.731s-.05 1.94-.13 2.731l-.066.572c-.023.183-.048.36-.074.528l-.08.485l-.086.443l-.089.4l-.089.36l-.088.317l-.043.144c-.331 1.087-1.464 1.505-2.394 1.195l-1.18-.393l-.4.933a2 2 0 0 1-2.47 1.11l-5.096-1.7a2 2 0 0 1-1.206-2.684l.269-.628L7 15.055l-1.368.456A2 2 0 0 1 3 13.613V9.388A2 2 0 0 1 5.632 7.49L7 7.946l10.861-3.62c.93-.31 2.063.107 2.394 1.194M9.682 15.948l-.335.78l5.096 1.7l.335-.781zm8.706-9.69L8 9.721v3.558l10.388 3.463l.077-.283l.08-.327l.04-.18l.078-.394a17.8 17.8 0 0 0 .076-.439l.07-.485c.112-.847.191-1.887.191-3.134c0-1.246-.08-2.287-.19-3.134l-.071-.485c-.025-.154-.05-.3-.076-.44l-.079-.393l-.08-.349zM5 9.388v4.225l1-.334V9.721z"/>
              </g>
            </svg>
            {{ 'Give us your feedback' | trans }}
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import currentJob from './../../mixins/current_job.mixin';
import ResultPageManager from '../../manager/MagicEditorManager';
import TabManager from "../../manager/TabManager";
import MagicEditorManager from "../../manager/MagicEditorManager";

export default {
  name: 'Topbar',
  props: {},
  components: {},
  mixins: [store, currentJob],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    createJob() {
      MagicEditorManager.newJob();
    },
    openTab(tab) {
      TabManager.openTab(tab);
    },
    onWheel: function (e) {
      if (e.deltaY > 0) {
        this.scrollRight();
      } else {
        this.scrollLeft();
      }
    },
    remove(tab) {
      TabManager.removeTab(tab, this.$route.path);
    },
    scrollLeft() {
      let content = document.getElementById('files-bar-container'),
          scrollStep = 200;

      let sl = content.scrollLeft;

      if (sl - scrollStep <= 0) {
        content.scrollTo(0, 0);
      } else {
        content.scrollTo(sl - scrollStep, 0);
      }
    },
    scrollRight() {
      let content = document.getElementById('files-bar-container'),
          scrollStep = 200;

      let sl = content.scrollLeft,
          cw = content.scrollWidth;

      if (sl + scrollStep >= cw) {
        content.scrollTo(cw, 0);
      } else {
        content.scrollTo(sl + scrollStep, 0);
      }
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
#topbar-left {
  display: flex;
  width: 100%;
  overflow: hidden;
}
.spin-circle-basic {
  border: 2px solid #2e2e2e;
  border-right-color: transparent;
  .dark-mode & {
    border: 2px solid white;
    border-right-color: transparent;
  }

  .active & {
    border: 2px solid white;
    border-right-color: transparent;
  }
}
.tab-icon {
  gap: 5px;
  display: flex;
  font-size: 12px;
  i {
    font-size: 14px;
  }
  align-items: center;
}
#main-nav {
  height: 100%;
  display: flex;
  align-items: center;
  gap: 20px;
  width: 180px;
  border-right: 1px solid #CBCBCB;

  .dark-mode & {
    border-right: 1px solid #595959;
  }
}

.nav-item {
  height: 100%;
  align-items: center;
  display: flex;
  gap: 10px;
  border-bottom: 3px solid transparent;
  padding: 3px 10px 0 10px;
  cursor: pointer;
}

.active {
  border-bottom: 3px solid #1266F1;
}

.exact-active {
  border-bottom: 3px solid #1266F1;
}

.nav-item-file-auto {
  width: auto !important;
  min-width: auto !important;
}

.nav-item-file {
  white-space: nowrap;
  cursor: default;
  overflow: hidden;
  padding: 0 20px;
  border-right: 1px solid #CBCBCB;
  gap: 10px;
  cursor: pointer;

  .dark-mode & {
    border-right: 1px solid #595959;
  }

  .file-text {
    max-width: 200px;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &.exact-active {
    height: 40px !important;
    padding-bottom: 1px;
    border-bottom: 0 !important;

    &:hover {
    }
  }

  &.active {
    border-bottom: 0 !important;
    background: #1266F1;
    color:white;

    &:hover {
      background: #1266F1 !important;
    }
  }
}

.open-files-nav {
  display: flex;
}

.open-files-nav .nav-item-file {
  border-bottom: 0px solid #595959;
  height: 100%;
  display: flex;
  align-items: center;
  min-width: 200px;
  justify-content: space-between;

  &:hover {
      background: #1266F1 !important;
  }
}

#topbar-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

#topbar-right {
  width: 380px;
  padding-left: 20px;
  min-width: 380px;
  border-left: 1px solid #CBCBCB;

  .dark-mode & {
    border-left: 1px solid #595959;
  }
}

#files-bar-container {
  overflow-x: scroll;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.nav-item {
  &:hover {
    //background: #2c2c2c;
  }
}

.nav-item-file-new {
  width: 100px;
  min-width: 100px !important;
}

.lang-ru .nav-item-file-new {
  min-width: 118px !important;
}

.topbar-scroll-container {
  width: 50px;
  border-left: 1px solid #CBCBCB;
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: #2c2c2c;
  }
}
</style>
